import React, { useState } from 'react';
import SearchAdjustmentsDialog from './SearchAdjustmentsDialog';
import SecurityAdjustmentsListingDialog from './SecurityAdjustmentsListingDialog';
import { fetchAdjustments } from './utils';
import ALoader from '../../../../../common/a-loader';

const SecurityAdjustment = ({
    searchAdjustmentsDialogInfo,
    setSearchAdjustmentsDialogInfo,
    applicationDetails,
    fetchOtherChargesList
}) => {

    const [listingDialogOpen, setListingDialogOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [adjustmentsList, setAdjustmentsList] = useState([]);

    const getSecurityAdjustments = async (psid) => {
        try {
            setLoading(true);
            const resp = await fetchAdjustments(psid, applicationDetails);
            if (resp?.code === 200) {
                setAdjustmentsList(resp?.data);
                setListingDialogOpen(true);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const closeSearchDialog = () => {
        setSearchAdjustmentsDialogInfo({ isOpen: false, chargesDetails: {} })
    }

    return (
        <div>
            {loading && <ALoader position={"fixed"} zIndex={9999} />}

            <SearchAdjustmentsDialog
                open={searchAdjustmentsDialogInfo?.isOpen}
                closeDialog={closeSearchDialog}
                handleSearch={getSecurityAdjustments}
            />

            <SecurityAdjustmentsListingDialog
                open={listingDialogOpen}
                setOpen={setListingDialogOpen}
                applicationDetails={applicationDetails}
                adjustmentsList={adjustmentsList}
                securityChargeDetails={searchAdjustmentsDialogInfo?.chargesDetails}
                setLoading={setLoading}
                getSecurityAdjustments={getSecurityAdjustments}
                closeSearchDialog={closeSearchDialog}
                fetchOtherChargesList={fetchOtherChargesList}
            />
        </div>
    );
}

export default SecurityAdjustment;